import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Insurance = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = '#FF2B35', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 49 49"
      fill="none"
      {...rest}
    >
      <path
        d="M34.6986 44.886C40.0005 44.886 44.2986 40.5879 44.2986 35.286C44.2986 29.9841 40.0005 25.686 34.6986 25.686C29.3967 25.686 25.0986 29.9841 25.0986 35.286C25.0986 40.5879 29.3967 44.886 34.6986 44.886Z"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.2787 35.406H31.1187"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6987 31.906V39.0859"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M44.2988 18.266C44.2988 22.206 43.2788 25.6859 41.6788 28.7059C39.9188 26.8459 37.4389 25.686 34.6989 25.686C29.3989 25.686 25.0989 29.986 25.0989 35.286C25.0989 37.746 26.0388 39.986 27.5588 41.686C26.8188 42.026 26.1388 42.306 25.5388 42.506C24.8588 42.746 23.7388 42.746 23.0588 42.506C17.2588 40.526 4.29883 32.266 4.29883 18.266C4.29883 12.086 9.27882 7.08594 15.4188 7.08594C19.0388 7.08594 22.2788 8.84602 24.2988 11.546C26.3188 8.84602 29.5588 7.08594 33.1788 7.08594C39.3188 7.08594 44.2988 12.086 44.2988 18.266Z"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Insurance.displayName = 'Insurance';
